import { AlertType, AlertLabel } from '../../types/alerts';

const alertTypeOptions = [
  { label: AlertLabel.ADVISORY, value: AlertType.WARNING },
  { label: AlertLabel.CLOSURE, value: AlertType.CLOSURE },
  { label: AlertLabel.INFORMATION, value: AlertType.INFORMATION }
];

const alertReasonOptions = [
  { label: 'COVID-19', value: 'covid' },
  { label: 'Event', value: 'event' },
  { label: 'Entry fee', value: 'fee' },
  { label: 'Prescribed burn', value: 'burn' }
];

export { alertTypeOptions, alertReasonOptions };
